export const INTRO_BLOG_BLUEPRINT_MODULE_COMPLETE_KEY =
	'com.atlassian.confluence.plugins.confluence-business-blueprints:introductory-blog-blueprint';
